import { createElement } from 'react';
import { oneOf, node, string, bool } from 'prop-types';
import { breakpointPropType } from './types/props.js';
import { b as _objectWithoutPropertiesLoose, c as _extends } from './chunk-ad6ad343.js';
import _Container from './Container/styled.js';

var Container = function Container(_ref) {
  var align = _ref.align,
      children = _ref.children,
      className = _ref.className,
      props = _objectWithoutPropertiesLoose(_ref, ["align", "children", "className"]);

  return createElement(_Container, _extends({
    className: className,
    align: align
  }, props), children);
};

var containerPropTypes = {
  align: oneOf(['left', 'right', 'center']),
  breakpoint: breakpointPropType,
  children: node.isRequired,
  className: string,
  isFluid: bool,
  isLayout: bool
};
Container.propTypes = containerPropTypes;
var containerDefaultProps = {
  align: 'center',
  breakpoint: undefined,
  className: undefined,
  isFluid: false,
  isLayout: false
};
Container.defaultProps = containerDefaultProps;
var C = Container;
export { C as a, containerPropTypes as b, containerDefaultProps as c };